import { clearAutocompleteState, fetchAutompleteResult } from "fe2/Actions/ActionAutocomplete";
import { fetchClan } from "fe2/Actions/ActionClanProfile";
import { getLeagueDivisionRating, setCurrentClanId, toggleCrossRealmLadder, toggleCurrentRealm, toggleCurrentSeason, toggleCurrentSeasonType, toggleDivision, toggleLeague, toggleRatingFetch } from "fe2/Actions/ActionClanRating";
import { hideDialog, showDialog } from "fe2/Actions/ActionDialog";
import { appendTermToHistory, changePage, changeTerm, clearSearchState, fetchSearchResult } from "fe2/Actions/ActionSearch";
import { BattleInfoDialog } from "fe2/Components/UIKit/UIKit";
import { getLastSeason, isGlobalSearchEnabled } from "helpers/ladder";
import { getLocalizationSafe } from "helpers/localization";
import { getSeasonInfo } from "helpers/seasons";
import isEmpty from "lodash/isEmpty";
import * as React from "react";
import { connect } from "react-redux";
import { batchActions } from "redux-batched-actions";
import settings from "settings";
import { ClansRating } from "UIKit";
import { openUrlInExternalBrowser } from "web2ClientAPI/web2ClientAPI";
import { TYPE_GLOBAL_SEARCH } from "../Actions/ActionClanRating";

const getRatingRealm = (id, currentSeason, state) => {
  if (!state.clans.wowsLadder[id]) {
    return null
  }
  const ratingArray = state.clans.wowsLadder[id].ratings.filter(rating => rating.season_number === currentSeason);
  return ratingArray.length > 0 ? ratingArray[0].realm : null;
};

const mapStateToProps = state => {
  let ladder = getSeasonInfo(state.clansRating.currentSeason);
  const hasError = isEmpty(ladder) || !ladder;
  const currentSeason = parseInt(state.clansRating.currentSeason);
  const lastSeason = getLastSeason() || {};
  const clanHomeRealm = settings.realm.code;
  const currentRealm = state.clansRating.currentRealm || (isGlobalSearchEnabled ? TYPE_GLOBAL_SEARCH : clanHomeRealm);
  return {
    hasError: hasError,
    autocomplete: state.autocomplete,
    currentAccount: state.currentAccount,
    clanInfo: state.clans.items[state.currentAccount.clanId],
    clanId: state.currentAccount.clanId,
    currentClanId: state.clansRating.currentClanId,
    leagues: ladder.leagues,
    seasonType: ladder.kind,
    currentRealm,
    seasonInfo: {
      icons: ladder.icons,
      name: getLocalizationSafe(ladder, 'title')
    },
    currentLeague: state.clansRating.currentLeague,
    currentDivision: state.clansRating.currentDivision,
    isCrossRealmLadder: state.clansRating.isCrossRealmLadder,
    currentSeasonType: state.clansRating.currentSeasonType || lastSeason.kind,
    currentSeason: currentSeason,
    ratingLists: state.clansRating.ratingLists,
    isError: state.clansRating.isError,
    isFetching: state.clansRating.isFetching,
    errorMessage: state.clansRating.errorMessage,
    wowsLadder: state.clans.wowsLadder[state.currentAccount.clanId],
    searchResult: state.searchResult,
    root: state.urls.root,
    clanBattlesInfoContent: state.content,

    // TODO: Define clanHomeRealm by Ladder's settings (after ladder fixes)
    // clanHomeRealm: state.currentAccount.clanId ? state.clans.wowsLadder[state.currentAccount.clanId].realm : null,
    clanHomeRealm,
    clanBattleRealm: state.currentAccount.clanId ? getRatingRealm(state.currentAccount.clanId, currentSeason, state) : null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDivisionChange: (division, ladderIsUpdate) => {
      dispatch(toggleDivision(division, ladderIsUpdate));
    },
    onLeagueChange: (league, ladderIsUpdate) => {
      dispatch(toggleLeague(league, ladderIsUpdate));
    },
    onLeagueAndDivisionChange: ({
      league,
      division,
      clanId,
      withGlobalSpinner,
      ownClan
    }) => {
      dispatch(getLeagueDivisionRating({ league, division, clanId }, withGlobalSpinner, ownClan));
    },
    onCrossRealmChange: isCrossRealm => {
      dispatch(toggleCrossRealmLadder(isCrossRealm));
    },
    onSeasonTypeChange: seasonType => {
      dispatch(changeTerm(''));
      dispatch(toggleCurrentSeasonType(seasonType));
      dispatch(batchActions([clearAutocompleteState(), clearSearchState()]));
    },
    onSeasonChange: season => {
      dispatch(changeTerm(''));
      dispatch(toggleCurrentSeason(season));
      dispatch(batchActions([clearAutocompleteState(), clearSearchState()]));
    },
    onRealmChange: realm => {
      dispatch(changeTerm(''));
      dispatch(toggleCurrentRealm(realm));
      dispatch(batchActions([clearAutocompleteState(), clearSearchState()]));
    },
    onRender: clanId => {
      dispatch(fetchClan(clanId));
    },
    toggleRatingFetch: isFetching => {
      dispatch(toggleRatingFetch(isFetching));
    },
    setCurrentClanId(clanId) {
      dispatch(setCurrentClanId(clanId));
    },
    clearState: () => {
      dispatch(batchActions([clearAutocompleteState(), clearSearchState()]));
    },
    onAutocompleteItemClick: (item, accountId) => {
      dispatch(appendTermToHistory(item, accountId));
    },
    onSearchInputChange: term => {
      return dispatch(fetchAutompleteResult(term, 'clansRating'));
    },
    onSubmit: term => {
      dispatch(changeTerm(term));
      return dispatch(fetchSearchResult('clansRating'));
    },
    onReloadClick: () => {
      return dispatch(fetchSearchResult('clansRating'));
    },
    onPageChanged: page => {
      dispatch(changePage(page));
      return dispatch(fetchSearchResult('clansRating'));
    },
    onBattleInfoClick: dialogContent => {
      if (!dialogContent) {
        return;
      }

      const battlesInfoContent = dialogContent.clanBattlesPage || {};
      const url = battlesInfoContent.more_link || '';

      const content = <BattleInfoDialog clanBattlesInfoContent={dialogContent} hideDialog={() => dispatch(hideDialog())} openBattlesInfoUrl={() => openUrlInExternalBrowser(url)} />;
      dispatch(showDialog(content, 'info'));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClansRating);